export default __webpack_public_path__ + "static/wsg-1-1e75ea46982db9c1912cdf8fd80ea3f4.jpg";